export default __webpack_public_path__ + "static/media/speechml.e498dc92.png";